export const digitalSubscriptionsBlue = '#00568D';
export const guardianWeeklyBlue = '#66c2e9';
export const paperSubscriptionsBlue = '#90DCFF';
export const offerStraplineBlue = '#C1D8FC';
export const guardianWeeklyHeroBlue = '#CADBE8';
